var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.651,
    height: 64.301,
    viewBox: "0 0 53.651 64.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_46",
    "data-name": "Komponente 10 \\u2013 46",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pie-chart-1",
    transform: "translate(-42.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35411",
    "data-name": "Gruppe 35411",
    transform: "translate(42.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46738",
    "data-name": "Pfad 46738",
    d: "M89.513,50.107a23.188,23.188,0,0,0-8.445-17.883l1.34-2.188h6.168a.938.938,0,0,0,0-1.875H81.883a.937.937,0,0,0-.8.448L79.57,31.08a23.584,23.584,0,0,0-25.755-.847.937.937,0,0,0,.974,1.6,21.71,21.71,0,0,1,23.8.847l-6.077,9.923a.938.938,0,1,0,1.6.979l5.967-9.744a21.322,21.322,0,0,1,7.54,15.329H66.246L46.6,40.844a21.443,21.443,0,0,1,4.977-6.622.937.937,0,1,0-1.253-1.395,23.184,23.184,0,0,0,2.833,36.725L50.4,74.058H44.225a.938.938,0,0,0,0,1.875h6.7a.938.938,0,0,0,.8-.448l3.042-4.967A23.444,23.444,0,0,0,66.055,73.4a.938.938,0,0,0,.938-.937V51.045H88.576a.937.937,0,0,0,.937-.937ZM55.744,68.918l1.959-3.2a.937.937,0,1,0-1.6-.979l-1.968,3.213a21.279,21.279,0,0,1-8.276-25.387l19.258,8.162V71.5A21.557,21.557,0,0,1,55.744,68.918Z",
    transform: "translate(-42.597 -23.463)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46742",
    "data-name": "Pfad 46742",
    d: "M350.32,1.875h6.693a.937.937,0,1,0,0-1.875H350.32a.937.937,0,1,0,0,1.875Z",
    transform: "translate(-311.035)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46743",
    "data-name": "Pfad 46743",
    d: "M55.758,442.348h-6.7a.938.938,0,0,0,0,1.875h6.7a.938.938,0,1,0,0-1.875Z",
    transform: "translate(-47.433 -387.055)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46744",
    "data-name": "Pfad 46744",
    d: "M293.267,280.8H287.1l-2.1-3.428a23.314,23.314,0,0,0,13.637-21.15.938.938,0,0,0-.937-.937H284.81a.938.938,0,0,0,0,1.875h11.929a21.457,21.457,0,0,1-12.728,18.6l-3.731-6.093a.938.938,0,0,0-1.6.979l3.559,5.813a21.6,21.6,0,0,1-6.127,1.159v-20.46h4.7a.938.938,0,0,0,0-1.875h-5.634a.938.938,0,0,0-.937.938v22.355a.938.938,0,0,0,.938.938,23.5,23.5,0,0,0,8.066-1.419l2.53,4.131a.937.937,0,0,0,.8.448h6.7a.937.937,0,1,0,0-1.875Z",
    transform: "translate(-245.283 -223.378)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46745",
    "data-name": "Pfad 46745",
    d: "M373.032,497h-6.7a.938.938,0,0,0,0,1.875h6.7a.938.938,0,0,0,0-1.875Z",
    transform: "translate(-325.048 -434.875)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(19 20)",
    fill: "#a5b5af",
    fontSize: 12,
    fontFamily: "Rubik-SemiBold, Rubik",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "K",
    transform: "translate(9 37)",
    fill: "#a5b5af",
    fontSize: 12,
    fontFamily: "Rubik-SemiBold, Rubik",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "K")), /*#__PURE__*/React.createElement("text", {
    id: "F",
    transform: "translate(36 45)",
    fill: "#a5b5af",
    fontSize: 12,
    fontFamily: "Rubik-SemiBold, Rubik",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.2aafc794c1a8764bdfaa578bb5a42511.svg";
export { ForwardRef as ReactComponent };